export default "__VITE_ASSET__DJH57LL8__"